import { render, staticRenderFns } from "./DataLoading.vue?vue&type=template&id=19fa2bc1&scoped=true"
import script from "./DataLoading.vue?vue&type=script&lang=js"
export * from "./DataLoading.vue?vue&type=script&lang=js"
import style0 from "./DataLoading.vue?vue&type=style&index=0&id=19fa2bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa2bc1",
  null
  
)

export default component.exports